import { BrowserRouter, Route, Switch } from 'react-router-dom'
import 'antd/dist/reset.css'
import {
  ConfigProvider,
  DatePicker,
  Input,
  InputNumber,
  Select,
  Collapse,
  Tabs,
  message,
  Modal,
  Drawer,
} from 'antd'
import { useEffect } from 'react'
import { CaretDownFilled, CaretRightOutlined } from '@ant-design/icons'
import { Provider } from 'react-redux'
import { SIMPLUS_LOCALE } from './constants/antdLocale'
import DefaultLayout from './views/defaultLayout'
import LoginPage from './views/LoginPage'
import './styles/index.scss'
import store from './redux/store'

Select.defaultProps = {
  suffixIcon: <CaretDownFilled />,
  size: 'large',
  style: { width: '100%' },
}

DatePicker.defaultProps = {
  size: 'large',
  style: { width: '100%' },
  format: 'DD/MM/YYYY',
}

Input.defaultProps = {
  size: 'large',
  style: { width: '100%' },
}

InputNumber.defaultProps = {
  size: 'large',
  style: { width: '100%' },
}

Collapse.defaultProps = {
  bordered: false,
  expandIcon: ({ isActive }) => (
    <CaretRightOutlined rotate={isActive ? 90 : 0} />
  ),
}

Tabs.defaultProps = {
  tabBarGutter: 0,
}

// Set default keyboard={false} for Modal and Drawer components
Modal.defaultProps = {
  ...Modal.defaultProps,
  keyboard: false,
  centered: true,
}

Drawer.defaultProps = {
  ...Drawer.defaultProps,
  keyboard: false,
}

// Override Modal static methods to include keyboard: false by default
const originalConfirm = Modal.confirm
const originalSuccess = Modal.success
const originalError = Modal.error
const originalWarning = Modal.warning
const originalInfo = Modal.info

Modal.confirm = (config) => originalConfirm({
  ...config,
  keyboard: false,
  centered: true,
})

Modal.success = (config) => originalSuccess({
  ...config,
  keyboard: false,
  centered: true,
})

Modal.error = (config) => originalError({
  ...config,
  keyboard: false,
  centered: true,
})

Modal.warning = (config) => originalWarning({
  ...config,
  keyboard: false,
  centered: true,
})

Modal.info = (config) => originalInfo({
  ...config,
  keyboard: false,
  centered: true,
})

/**
 * Màu chủ đạo của antd cho TOÀN BỘ ERP.
 *
 * Trước đây repo không cấu hình `ConfigProvider` nào, nên antd v5 dùng mặc định
 * là xanh DƯƠNG `#1677ff`: tab đang chọn, gạch chân tab, màu hover, vòng radio /
 * checkbox, viền focus của ô nhập… đều ra xanh dương giữa một giao diện xanh lá.
 * Từng màn phải tự đè lại bằng SCSS, và chỗ nào quên đè thì lộ màu xanh dương.
 *
 * Đặt token ở đây là sửa MỘT chỗ cho tất cả — kể cả các trạng thái không có
 * class riêng để đè như `:hover`, `:active`, viền focus.
 *
 * 🔴 Đây là thay đổi phạm vi TOÀN ỨNG DỤNG. Đổi giá trị này là đổi màu mọi màn.
 * Mã màu lấy từ Figma (`Light/Green/Base`).
 */
const SIMPLUS_THEME = {
  token: {
    colorPrimary: '#00ba34',
    // Cùng họ với `colorPrimary` để link và thông tin không lạc về xanh dương.
    colorLink: '#00ba34',
    colorInfo: '#00ba34',
  },
}

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={SIMPLUS_THEME} locale={SIMPLUS_LOCALE}>
        <BrowserRouter>
          <Switch>
            <Route path="/login" name="Login" component={LoginPage} />
            <Route path="/" name="Default Layout" component={DefaultLayout} />
          </Switch>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  )
}

export default App
